import configAll from '../config.json'

export const NODE_ENV = process.env.REACT_APP_NODE_ENV || 'development'

const config = configAll[NODE_ENV]
export default config